<template>
  <div>
    <div class="menu-item" v-for="(menu_item, m_index) in visibleMenuItems" :key="m_index"
         :class="(isUrl(menu_item.url) || isSubmenuActive(menu_item.submenu)) ? ' active' : ''" v-on="menu_item.submenu?{click: (e) => addActiveClass(e)}:{}">
      <Link class="flex items-center group py-3 menu-link" :href="menu_item.route?route(menu_item.route):'#'" :class="{'have-sub-menu': menu_item.submenu}">
        <icon :name="menu_item.icon" class="w-6 h-6 mr-3 rtl:ml-3 menu__icon" />
        <div class="menu__name">{{ __(menu_item.name) }}</div>
      </Link>
        <div v-if="menu_item.submenu" class="sub-menu-items">
            <Link class="sub-menu-item" v-for="(sub_menu_item, s_m_index) in menu_item.submenu" :key="s_m_index"
                :class="this.isUrl(sub_menu_item.url) ? ' active' : ''" :href="sub_menu_item.param?route(sub_menu_item.route,sub_menu_item.param):route(sub_menu_item.route)">
                <icon v-if="sub_menu_item.icon" :name="sub_menu_item.icon" class="w-4 h-4 mr-1 menu__icon" />
                <icon v-else name="dash" class="w-4 h-4 mr-1 menu__icon" />
                <div class="menu__name">{{ __(sub_menu_item.name) }}</div>
            </Link>
        </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import { Link } from '@inertiajs/vue3'

export default {
  components: {
    Icon,
      Link,
  },
    data(){
      return{
          user: null,
          menu_items: [
              // Dashboard shows platform-wide admin analytics; the Customer role is
              // redirected away from it server-side (RedirectIfCustomer), so hide the link.
              {'name': 'Dashboard', 'route': 'dashboard', 'url': 'admin', 'icon': 'dashboard', 'hiddenForCustomer': true},

              // User Management
              {'name': 'User Management', 'route': '', 'url': 'user-management', 'icon': 'users',
                  'submenu': [
                      {'name': 'Users', 'route': 'users', 'url': 'users', 'icon': 'users', 'module': 'user'},
                      {'name': 'Roles', 'route': 'roles', 'url': 'roles', 'icon': 'security', 'module': 'role'},
                  ]
              },

              // Products - the digital assets users create in the platform
              {'name': 'Products', 'route': '', 'url': 'products', 'icon': 'card',
                  'submenu': [
                      {'name': 'Custom Cards', 'route': 'cards', 'url': 'cards', 'icon': 'card', 'module': 'card'},
                      {'name': 'Landing Pages', 'route': 'admin.landing-pages.index', 'url': 'landing-pages', 'icon': 'page', 'module': 'landing_page'},
                      {'name': 'Resumes', 'route': 'admin.resumes.index', 'url': 'resumes', 'icon': 'file', 'module': 'resume'},
                      {'name': 'Link-in-Bio', 'route': 'admin.link-in-bio.index', 'url': 'link-in-bio', 'icon': 'website', 'module': 'link_in_bio'},
                  ]
              },

              // Leads Management
              {'name': 'Leads', 'route': '', 'url': 'leads-management', 'icon': 'contact',
                  'submenu': [
                      {'name': 'Leads', 'route': 'admin.leads.index', 'url': 'leads', 'icon': 'contact', 'module': 'lead'},
                      {'name': 'Lead Forms', 'route': 'admin.lead-forms.index', 'url': 'lead-forms', 'icon': 'ticket', 'module': 'lead_form'},
                  ]
              },

              // Site Content
              {'name': 'Content', 'route': '', 'url': 'content', 'icon': 'post',
                  'submenu': [
                      {'name': 'Blog', 'route': 'posts', 'url': 'posts', 'icon': 'post', 'module': 'blog'},
                      {'name': 'FAQs', 'route': 'faqs', 'url': 'faqs', 'icon': 'faq', 'module': 'faq'},
                      {'name': 'Knowledge Base', 'route': 'admin.knowledge-base.index', 'url': 'knowledge-base', 'icon': 'knowledge', 'module': 'knowledge_base'},
                  ]
              },

              // Settings
              {'name': 'Settings', 'route': '', 'url': 'settings', 'icon': 'gear',
                  'submenu': [
                      {'name': 'Global Settings', 'route': 'global', 'url': 'settings/global', 'icon': 'gear', 'module': 'global'},
                      {'name': 'Languages', 'route': 'languages', 'url': 'settings/languages', 'icon': 'global_setting', 'module': 'language'},
                      {'name': 'Types', 'route': 'types', 'url': 'settings/types', 'icon': 'types', 'module': 'type'},
                      {'name': 'License', 'route': 'license.settings', 'url': 'settings/license', 'icon': 'license', 'module': 'license'},
                  ]
              },
          ]
      }
    },
  computed: {
    visibleMenuItems() {
      return this.menu_items
        .map(menu_item => {
          if (menu_item.hiddenForCustomer && this.user?.role?.slug === 'customer') {
            return null
          }
          if (menu_item.submenu) {
            const submenu = menu_item.submenu.filter(sub_menu_item => this.canAccess(sub_menu_item.module))
            if (submenu.length === 0) {
              return null
            }
            return { ...menu_item, submenu }
          }
          return this.canAccess(menu_item.module) ? menu_item : null
        })
        .filter(menu_item => menu_item !== null)
    },
  },
  methods: {
    // No module means the item isn't gated (e.g. Dashboard). Admins always see everything.
    canAccess(module) {
      if (!module) {
        return true
      }
      if (!this.user || !this.user.role) {
        return false
      }
      if (this.user.role.slug === 'admin') {
        return true
      }
      return !!this.user.role.access?.[module]?.read
    },
    isUrl(...urls) {
      if (!this.$page || !this.$page.url) {
        return false
      }
      
      // Get current URL and normalize it
      let currentUrl = this.$page.url
      
      // Remove leading slash if present
      if (currentUrl.startsWith('/')) {
        currentUrl = currentUrl.substring(1)
      }
      
      // Remove trailing slash if present
      if (currentUrl.endsWith('/')) {
        currentUrl = currentUrl.slice(0, -1)
      }
      
      // Remove 'admin/' prefix if present
      if (currentUrl.startsWith('admin/')) {
        currentUrl = currentUrl.substring(6) // 'admin/'.length = 6
      } else if (currentUrl === 'admin') {
        currentUrl = ''
      }
      
      // Handle empty URL (dashboard)
      if (urls[0] === '' || urls[0] === 'admin') {
        return currentUrl === '' || currentUrl === 'admin'
      }
      
      // Check if current URL matches any of the provided URLs
      return urls.some(url => {
        if (!url) return false
        
        // Normalize the menu URL (remove trailing slash)
        const normalizedUrl = url.endsWith('/') ? url.slice(0, -1) : url
        
        // Exact match
        if (currentUrl === normalizedUrl) {
          return true
        }
        
        // Check if current URL starts with the menu URL (for sub-routes)
        // e.g., 'landing-pages' should match 'landing-pages/123'
        // e.g., 'settings/global' should match 'settings/global' exactly
        if (currentUrl.startsWith(normalizedUrl + '/')) {
          return true
        }
        
        return false
      })
    },
    addActiveClass(e){
      e.currentTarget.classList.toggle('hover')
    },
    // Check if any submenu item is active (for parent menu highlighting)
    isSubmenuActive(submenu) {
      if (!submenu || !Array.isArray(submenu)) {
        return false
      }
      return submenu.some(item => {
        if (!item || !item.url) return false
        return this.isUrl(item.url)
      })
    }
  },
    created() {
      this.user = this.$page.props.auth.user;
    }
}
</script>
